import axios from 'axios';

const api = '/api/nfa-cards';

export const getCard = id => {
  return axios.get(`${api}/${id}?cacheBuster=${new Date().getTime()}`);
};

export const createCard = data => {
  return axios.post(`${api}?cacheBuster=${new Date().getTime()}`, data);
};

export const updateCard = (id, data) => {
  return axios.put(`${api}/${id}?cacheBuster=${new Date().getTime()}`, data);
};

export const deleteCard = id => {
  return axios.delete(`${api}/${id}?cacheBuster=${new Date().getTime()}`);
};
